module.exports = __webpack_public_path__ + "static/greycosysheepsuitcase-61308f6f6741fe34aefad40e8972d1a1.jpeg";